import { gql } from '@apollo/client'

export const CONVERSATION_MESSAGE_ATTRIBUTES = gql`
  fragment conversationMessageAttributes on ConversationMessage {
    id
    createdAt
    content
    sender {
      id
      worker {
        id
        user {
          id
          firstName
          lastName
        }
      }
      adminUser {
        id
        user {
          id
          firstName
          lastName
        }
      }
      subcontractor {
        id
        company {
          name
        }
      }
    }
    attachments {
      id
      url
      thumbnail {
        small
      }
    }
  }
`

export const CONVERSATION_THREAD_ATTRIBUTES = gql`
  fragment conversationThreadAttributes on ConversationThread {
    id
    messages {
      ...conversationMessageAttributes
    }
  }
  ${CONVERSATION_MESSAGE_ATTRIBUTES}
`

export const CONVERSATION_THREAD_RESOURCE_LINK_ATTRIBUTES = gql`
  fragment conversationThreadResourceLinkAttributes on ConversationThread_ResourceLink {
    id
    messages {
      id
      createdAt
      content
      sender {
        id
        worker {
          id
          user {
            id
            firstName
            lastName
          }
        }
        adminUser {
          id
          user {
            id
            firstName
            lastName
          }
        }
        subcontractor {
          id
          company {
            name
          }
        }
      }
      attachments {
        id
        url
        thumbnail {
          small
        }
      }
    }
  }
`

export const CONVERSATION_THREAD_ENTITY_ATTRIBUTES = gql`
  fragment conversationThreadEntityAttributes on ConversationThreadEntity {
    id
    messages {
      id
      createdAt
      content
      sender {
        id
        worker {
          id
          user {
            id
            firstName
            lastName
          }
        }
        adminUser {
          id
          user {
            id
            firstName
            lastName
          }
        }
        subcontractor {
          id
          company {
            name
          }
        }
      }
      attachments {
        id
        url
        thumbnail {
          small
        }
      }
    }
  }
`

export const CREATE_CONVERSATION_MESSAGE = gql`
  mutation createConversationMessage_UI(
    $input: CreateConversationMessageInput!
  ) {
    createConversationMessage(input: $input) {
      id
    }
  }
`

export const CREATE_PUBLIC_CONVERSATION_MESSAGE_AS_SUBCONTRACTOR = gql`
  mutation createPublicConversationMessageAsSubcontractor_UI(
    $input: CreatePublicConversationMessageAsSubcontractorInput!
  ) {
    createPublicConversationMessageAsSubcontractor(input: $input) {
      id
    }
  }
`

export const GET_KNOCK_MESSAGE_CONTENT = gql`
  query knockMessageContent_UI($logId: String!) {
    knockMessageContent_admin(logId: $logId) {
      html_body
      text_body
      subject
      to
    }
  }
`

export const KNOCK_MESSAGE_LOG_ATTRIBUTES = gql`
  fragment knockMessageLogAttributes on KnockMessageLog_Admin {
    id
    logDate
    status
    messageId
    sentTo {
      id
      name
    }
  }
`
